import { API_V2 } from './apiVersion';

export const ADMIN_USER_ENDPOINTS = {
  LIST: `${API_V2}/admin/users`,
  PENDING: `${API_V2}/admin/users/pending`,
  SEARCH: `${API_V2}/admin/users/search`,

  BY_ID: (id: number) =>
    `${API_V2}/admin/users/by-id/${id}`,

  APPROVE: (userId: string) =>
    `${API_V2}/admin/users/${encodeURIComponent(userId)}/approve`,

  REJECT: (userId: string) =>
    `${API_V2}/admin/users/${encodeURIComponent(userId)}/reject`,

  ACTIVATE: (userId: string) =>
    `${API_V2}/admin/users/${encodeURIComponent(userId)}/activate`,

  DEACTIVATE: (userId: string) =>
    `${API_V2}/admin/users/${encodeURIComponent(userId)}/deactivate`,

  RESET_PASSWORD: `${API_V2}/admin/users/password/reset`,

  POINTS: (userId: string) =>
    `${API_V2}/admin/users/${encodeURIComponent(userId)}/points`,

  STORE_POINTS: (userId: string) =>
    `${API_V2}/admin/users/${encodeURIComponent(userId)}/store-points`,

  GRANT_STORE_POINTS: (userId: string) =>
    `${API_V2}/admin/users/${encodeURIComponent(userId)}/store-points/grant`,

  SCORES: (userId: string) =>
    `${API_V2}/admin/users/${encodeURIComponent(userId)}/scores`,
} as const;
